import { CTAImage } from "@/assets/img/landing";
import { MoveUpRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export interface CTABannerProps {
  heading?: string;
  description?: string;
  buttonLabel?: string;
  buttonHref?: string;
  buttonVariant?: "gradient" | "cyber";
}

export function CTABanner({
  heading = "Lets Build Something That Works",
  description = "Get in touch to explore how we can support your cybersecurity and AI goals with practical, scalable solutions.",
  buttonLabel = "Get Cyber-Ready for €600",
  buttonHref = "/contact-us?interest=Cyber-Ready",
  buttonVariant = "cyber",
}: CTABannerProps = {}) {
  const isGradient = buttonVariant === "gradient";

  return (
    <>
      <section className="px-4 sm:px-6 py-6 font-sans">
        <div className="relative w-full lg:flex flex-col sm:flex-row rounded-3xl justify-between bg-[#dde8f5] overflow-hidden">
          <div className="px-6 sm:px-10 lg:px-14 py-10 sm:py-16 lg:py-20 flex flex-col justify-center w-full lg:max-w-[62%] z-10">
            <h2 className="text-[28px] sm:text-[38px] lg:text-[46px] font-bold text-[#2d3a6b] leading-tight mb-4">
              {heading}
            </h2>
            <p className="text-slate-600 text-[14px] sm:text-[16px] leading-relaxed mb-7 max-w-xl">
              {description}
            </p>
            <div>
              <Link href={buttonHref}>
                <button
                  className={
                    isGradient
                      ? "inline-flex items-center gap-2 text-white text-[14px] sm:text-[15px] font-medium px-7 py-3.5 rounded-full cursor-pointer hover:opacity-90 active:scale-[0.98] transition-all duration-300 bg-[linear-gradient(to_right,_#056686,_#8ABA28)] shadow-xs"
                      : "inline-flex items-center gap-2 h-[60px] text-white text-[1rem] font-medium px-6 py-3 rounded-full cursor-pointer hover:opacity-90 transition-opacity"
                  }
                  style={
                    !isGradient
                      ? {
                          background:
                            "linear-gradient(135deg, #2a9d6b, #1b6b5a)",
                        }
                      : undefined
                  }
                >
                  {buttonLabel}
                  <MoveUpRight size={16} />
                </button>
              </Link>
            </div>
          </div>
          <div className="hidden lg:flex sm:absolute sm:right-0 sm:bottom-0 sm:top-0 items-end justify-center sm:justify-end flex-shrink-0 mt-6 sm:mt-0 pointer-events-none select-none">
            <Image
              src={CTAImage.src}
              alt=""
              width={CTAImage.width}
              height={CTAImage.height}
              className="w-full sm:w-auto max-h-[300px] sm:max-h-full object-contain"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default CTABanner;
